import * as React from "react";
const SvgArrowCut = (props) => /* @__PURE__ */ React.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 8 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.5 12L6.5 7L1.5 2", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "square" }));
export default SvgArrowCut;
